import trans from "../../../../utils";
import WorkforceTotals from "./WorkforceTotals";

const STATE_COLORS = {
  A: { bg: "#f6ffed", border: "#b7eb8f", text: "#52c41a", activeBg: "#52c41a" },
  B: { bg: "#e6f7ff", border: "#91d5ff", text: "#1890ff", activeBg: "#1890ff" },
  C: { bg: "#fffbe6", border: "#ffe58f", text: "#faad14", activeBg: "#faad14" },
  D: { bg: "#fff1f0", border: "#ffa39e", text: "#ff4d4f", activeBg: "#ff4d4f" },
};

export default function InventoryReportWidgets({
  summary,
  filters,
  setFilters,
}) {
  if (!summary) return null;

  const {
    totalChecks,
    shelfAvailableRate,
    trueOOSRate,
    filteredResults,
    stateCounts = {},
  } = summary;

  const statCards = [
    { title: trans("Total Checks"), number: totalChecks },
    {
      title: trans("Shelf Availability Rate"),
      number: `${shelfAvailableRate ?? 0}%`,
    },
    { title: trans("True OOS Rate (D)"), number: `${trueOOSRate ?? 0}%` },
    { title: trans("Filtered Results"), number: filteredResults },
  ];

  const handleStateClick = (stateKey) => {
    if (filters?.states === stateKey) {
      setFilters((prev) => ({ ...prev, states: undefined }));
    } else {
      setFilters((prev) => ({ ...prev, states: stateKey }));
    }
  };

  return (
    <>
      <div className="row">
        {statCards.map((item, index) => (
          <div className="col-lg-3 col-md-6 centered-content" key={index}>
            <WorkforceTotals title={item.title} number={item.number} />
          </div>
        ))}
      </div>

      <div className="row mt-2">
        {["A", "B", "C", "D"].map((stateKey) => {
          const count = stateCounts[stateKey] ?? 0;
          const percentage =
            totalChecks > 0 ? ((count / totalChecks) * 100).toFixed(1) : "0.0";
          const isActive = filters?.states === stateKey;
          const colors = STATE_COLORS[stateKey];

          return (
            <div className="col-lg-3 col-md-6 centered-content" key={stateKey}>
              <div
                onClick={() => handleStateClick(stateKey)}
                style={{
                  cursor: "pointer",
                  backgroundColor: isActive ? colors.activeBg : colors.bg,
                  border: `2px solid ${isActive ? colors.activeBg : colors.border}`,
                  borderRadius: 8,
                  padding: "12px 16px",
                  margin: "0 0 12px",
                  textAlign: "center",
                  transition: "all 0.2s",
                  userSelect: "none",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: isActive ? "#fff" : colors.text,
                  }}
                >
                  {trans("State1")} {stateKey}
                </div>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: isActive ? "#fff" : "#333",
                  }}
                >
                  {count}
                </div>
                <div
                  style={{
                    fontSize: 13,
                    color: isActive ? "rgba(255,255,255,0.85)" : "#888",
                  }}
                >
                  {percentage}%
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
